import { render, staticRenderFns } from "./SessionNotificationWatcher.vue?vue&type=template&id=aff6716c"
import script from "./SessionNotificationWatcher.vue?vue&type=script&lang=js"
export * from "./SessionNotificationWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports